module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/glyphicons-halflings-regular.ttf
// module id = F7lN
// module chunks = 0